
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../.././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../.././shared/base.component';
import { LoaderService } from '../.././shared/loader.service';
import { TechnicianJobService } from '../../technician/technician-jobs/technician-jobs.service';
@Component({
    selector: 'metadata-info-popup',
    templateUrl: 'metadata-info-popup.component.html'
})
export class MetadataInfoPopupComponent extends BaseComponent implements OnInit {

    @Input() companyId: number;   
    @Input() filePath: string; 
    @Input() fileName: string; 
    @Output() Close = new EventEmitter();    
    loader: boolean = false;
     metadatList: any[];
    constructor(protected sharedService: SharedService, protected _technicianJobService: TechnicianJobService, private loaderService: LoaderService, private router: Router, protected translate: TranslateService) {
        super(sharedService, translate);
    }
    ngOnInit() {
        this.loaderService.show();
          this._technicianJobService.getMetaDataInfo(this.companyId, this.filePath,this.fileName)
            .subscribe(s => {
                 this.loaderService.hide(); 
                 this.metadatList=s;
            });
    }  
    close(success?: boolean) {
        this.loader = false;
        if (success || success == false) {
            this.Close.emit(success);
        }
        else if (success == null || success == undefined)
            this.Close.emit(null);
    }
}




